import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persistedstate'
import FloatingVue from 'floating-vue';
import VueGoodTablePlugin from 'vue-good-table-next';
import DataUtils from '@/utils/dataUtils.js';
import MoneyConvert from '@/utils/moneyConvert';
import Notiflix from '@/utils/notiflix';
import VueTheMask from 'vue-the-mask'
import money from 'v-money3'


// CSS
import 'floating-vue/dist/style.css';
import '@/assets/css/bootstrap.min.css';
import '@/assets/css/app.min.css';
import 'remixicon/fonts/remixicon.css';
import '@vueform/multiselect/themes/default.css'
import 'vue3-toastify/dist/index.css';
import 'vue-good-table-next/dist/vue-good-table-next.css'
import 'sweetalert2/dist/sweetalert2.min.css'

// Componentes
import ButtonField from './components/form/ButtonField.vue';
import InputField from './components/form/InputField.vue';
import ProgressBar from './components/widgets/ProgressBar.vue';
import SelectField from './components/form/SelectField.vue';
import Multiselect from '@vueform/multiselect';
import Vue3Toastify from 'vue3-toastify';
import BaseTable from './components/widgets/BaseTable.vue';
import VueSweetalert2 from 'vue-sweetalert2'
import NavBarLeft from './components/layout/NavBarLeft.vue';
import HeaderPage from './components/layout/HeaderPage.vue';
import { Dropdown } from 'floating-vue'
import BadgeField from './components/widgets/BadgeField.vue';
import OptionActionDataTable from './components/layout/OptionActionDataTable.vue';
import TextAreaField from './components/form/TextAreaField.vue';


const app = createApp(App);

const pinia = createPinia()
pinia.use(piniaPersist)

app.config.globalProperties.$dataUtils = new DataUtils();
app.config.globalProperties.$moneyConvert = new MoneyConvert();
app.config.globalProperties.$notiflix = Notiflix;

app.component('BaseTable', BaseTable)
app.component('TextAreaField', TextAreaField)
app.component('ButtonField', ButtonField)
app.component('InputField', InputField)
app.component('SelectField', SelectField)
app.component('MultiSelect', Multiselect)
app.component('NavBarLeft', NavBarLeft)
app.component('HeaderPage', HeaderPage)
app.component('DropdownFloating', Dropdown)
app.component('BadgeField', BadgeField)
app.component('OptionActionDataTable', OptionActionDataTable)
app.component('ProgressBar', ProgressBar)


const optionsSweetAlert = {
  confirmButtonColor: '#06d6a0',
  cancelButtonColor: '#ef476f',
  reverseButtons: true
}

app
  .use(VueTheMask)
  .use(money, { precision: 2 }) 
  .use(router)
  .use(VueSweetalert2, optionsSweetAlert)
  .use(VueGoodTablePlugin)
  .use( Vue3Toastify,
    {
      autoClose: 3000,
    }
  )
  .use(pinia)
  .use(FloatingVue)
  .mount('#app')
